import { DocumentType, ExtractionStatus } from "generated-graphql/graphql";

type PermitRenewalEligibilityInput = {
  documentType: DocumentType | null | undefined;
  extractionStatus?: ExtractionStatus | null;
  tenantId?: string | null;
  documentMetadata?: {
    dueDate?: string | Date | null;
    expirationDate?: string | Date | null;
  } | null;
  tasks?: Array<unknown> | null;
};

/**
 * Gate for offering permit-renewal generation. Requires a Permit with metadata,
 * a deadline (due or expiration date), a tenant, not mid-extraction, and no
 * related tasks yet (matches the review-dialog offer).
 */
export function canGeneratePermitRenewalForDocument(
  document: PermitRenewalEligibilityInput
): boolean {
  const metadata = document.documentMetadata;
  if (!metadata) {
    return false;
  }
  if (!metadata.dueDate && !metadata.expirationDate) {
    return false;
  }
  if ((document.tasks ?? []).length > 0) {
    return false;
  }
  return (
    document.documentType === DocumentType.Permit &&
    document.extractionStatus !== ExtractionStatus.Pending &&
    !!document.tenantId
  );
}

/**
 * Tooltip for the Create Permit Renewal Task footer toggle.
 * Locked copy when no deadline; outcome copy once a deadline is present.
 */
export function getPermitRenewalToggleTooltip(input: {
  documentType: DocumentType | null | undefined;
  dueDate?: string | Date | null;
  expirationDate?: string | Date | null;
  checked: boolean;
}): string | null {
  if (input.documentType !== DocumentType.Permit) {
    return null;
  }
  if (!input.dueDate && !input.expirationDate) {
    return "Set a due date or expiration to unlock";
  }
  if (input.checked) {
    return "Will create renewal task upon saving";
  }
  return "Will not create renewal task upon saving";
}
